import React from 'react';
import {
    GridContainer,
    ItemCardTextContainer,
    DesktopSetsList,
    MobileSetsList,
    BatchNum,
    BatchNumDiv,
    SetNum,
    SetDesc,
    BarCode,
} from './OnSubmit.styled';
import { BoxView } from 'src/pages/reportUsage/common/Common.styled.jsx';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { useTranslation } from 'react-i18next';
  
export const ALLDISTRICTS = 'ALL_Districts';
export const ALLTERRITORIES = 'All_Territories';
const ReceivedSets = ({ setsList }) => {
    const { t } = useTranslation();
    return (
        <>
            <DesktopSetsList>
                {setsList &&
                    setsList.map((item, index) => {
                        return (
                            <GridContainer
                                container
                                justifyContent={'space-between'}
                                direction="row"
                                key={index}
                            >
                                <ItemCardTextContainer
                                    item
                                    xs={6}
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    mobile={6}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                        }}
                                    >
                                        {!item.isBarCode && (
                                            <BoxView
                                                mr={'4px'}
                                                bgBorder={'1px solid #7ECA2A'}
                                                bgColor={'#7ECA2A80'}
                                                scrWidth={'21px'}
                                                mTop={'4px'}
                                                bRadius={'4px'}
                                            >
                                                <CustomLabel
                                                    fSize={'10px!important'}
                                                    letterSpacing={
                                                        '0px !important'
                                                    }
                                                    pt={'2px!important'}
                                                    fontFamily={
                                                        'AvenirNextWorld Demi'
                                                    }
                                                    opacity={'1'}
                                                    lineHeight={'20px'}
                                                    color={'#140F4B'}
                                                    label={'M'}
                                                />
                                            </BoxView>
                                        )}
                                        <SetNum
                                            display={'flex'}
                                            alignItems={'baseline'}
                                        >
                                            {' '}
                                            {item.setNo}
                                            <BarCode>
                                                &nbsp;|&nbsp;{t('receiveSets.ReceiveSubmit.ReceivedSets.barcode')}{' '}
                                                {item.barcode}
                                            </BarCode>{' '}
                                        </SetNum>
                                    </div>
                                    <SetDesc>
                                        {item.description
                                            ? item.description
                                            : ''}
                                    </SetDesc>
                                </ItemCardTextContainer>
                                <ItemCardTextContainer
                                    item
                                    xs={6}
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    mobile={6}
                                >
                                    <BatchNumDiv>
                                        <span
                                            style={{
                                                fontFamily:
                                                    'AvenirNextWorld Demi',
                                                paddingLeft: '30px',
                                            }}
                                        >
                                            {t('receiveSets.ReceiveSubmit.ReceivedSets.batch')}
                                        </span>
                                        <BatchNum> {item.batchNo}</BatchNum>
                                    </BatchNumDiv>
                                </ItemCardTextContainer>
                            </GridContainer>
                        );
                    })}
            </DesktopSetsList>

            <MobileSetsList>
                {setsList &&
                    setsList.map((item, index) => {
                        return (
                            <GridContainer
                                container
                                justifyContent={'space-between'}
                                direction="row"
                                key={index}
                            >
                                <ItemCardTextContainer
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    mobile={12}
                                    style={{ display: 'flex' }}
                                >
                                    {!item.isBarCode && (
                                        <BoxView
                                            mr={'4px'}
                                            bgBorder={'1px solid #7ECA2A'}
                                            bgColor={'#7ECA2A80'}
                                            scrWidth={'21px'}
                                            mTop={'4px'}
                                            bRadius={'4px'}
                                        >
                                            <CustomLabel
                                                fSize={'10px!important'}
                                                letterSpacing={'0px !important'}
                                                pt={'2px!important'}
                                                fontFamily={
                                                    'AvenirNextWorld Demi'
                                                }
                                                opacity={'1'}
                                                lineHeight={'20px'}
                                                color={'#140F4B'}
                                                label={'M'}
                                            />
                                        </BoxView>
                                    )}
                                    <SetNum
                                        display={'flex'}
                                        alignItems={'baseline'}
                                    >
                                        {item.setNo}
                                        <BarCode>
                                            &nbsp;|&nbsp;{t('receiveSets.ReceiveSubmit.ReceivedSets.barcode')} {item.barcode}
                                        </BarCode>
                                    </SetNum>
                                </ItemCardTextContainer>
                                <BatchNumDiv>
                                    <span
                                        style={{
                                            fontFamily: 'AvenirNextWorld Demi',
                                        }}
                                    >
                                       {t('receiveSets.ReceiveSubmit.ReceivedSets.batch')}
                                    </span>
                                    <BatchNum> {item.batchNo}</BatchNum>
                                </BatchNumDiv>
                                <SetDesc>
                                    {item.description ? item.description : ''}
                                </SetDesc>
                            </GridContainer>
                        );
                    })}
            </MobileSetsList>
        </>
    );
};

export default ReceivedSets;
